import { motion } from "framer-motion";

export function SectionDivider() {
  return (
    <div className="relative w-full h-16 flex items-center justify-center overflow-hidden bg-white dark:bg-black">
      {/* Animated background gradient */}
      <motion.div 
        className="absolute inset-0 "
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      />
      
      {/* Main divider line with animation */}
      <div className="relative w-full max-w-7xl h-px">
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-teal-500 to-transparent dark:via-teal-400"
          initial={{ width: 0 }}
          whileInView={{ width: "100%" }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: "easeInOut" }}
        />
        
        {/* Animated dots */}
        {[...Array(3)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute top-1/2 h-2 w-2 -translate-y-1/2 rounded-full bg-teal-500 dark:bg-teal-400"
            initial={{ x: 0, opacity: 0 }}
            whileInView={{ 
              x: [0, "100vw", 0],
              opacity: [0, 1, 0],
            }}
            viewport={{ once: true }}
            transition={{
              duration: 4,
              delay: i * 0.5,
              repeat: Infinity,
              repeatType: "loop",
              ease: "easeInOut",
            }}
            style={{
              left: `${(i + 1) * 25}%`,
              boxShadow: "0 0 10px 2px rgba(20, 184, 166, 0.5)",
            }}
          />
        ))}
        
        {/* Center accent */}
        <motion.div
          className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-teal-500 dark:bg-teal-400"
          initial={{ scale: 0 }}
          whileInView={{ 
            scale: [0, 1.5, 1],
            opacity: [0, 1, 1],
          }}
          viewport={{ once: true }}
          transition={{ 
            duration: 0.8,
            delay: 0.5 
          }}
          style={{
            boxShadow: "0 0 15px 3px rgba(20, 184, 166, 0.6)",
          }}
        />
      </div>
    </div>
  );
}
